import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import AddEditForm from '../components/addEditForm.vue';

var CopySeaFreightBookingPage = function (_super) {
  __extends(CopySeaFreightBookingPage, _super);

  function CopySeaFreightBookingPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopySeaFreightBookingPage = __decorate([Component({
    components: {
      AddEditForm: AddEditForm
    }
  })], CopySeaFreightBookingPage);
  return CopySeaFreightBookingPage;
}(Vue);

export default CopySeaFreightBookingPage;